import * as yup from "yup";
export const uploadSchema = yup.object().shape({
  url: yup
    .string()
    .required()
    .url("Please use a valid URL")
});
